module.exports = __webpack_public_path__ + "media/img/payments/payment-illustration-3-3e2501c426e1dd496cfeaa2a3db62e28.svg";